import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
const service = axios.create({
  baseURL: process.env.VUE_APP_ENV === 'uat' ? `${window.location.origin}/business-platform-service-uat` : `${window.location.origin}`,
  timeout: 100000
})

service.interceptors.request.use(config => {
  const Authorization = JSON.parse(localStorage.getItem('Authorization'))
  config.headers['X-Requested-With'] = 'XMLHttpRequest'
  if (Authorization) {
    config.headers['Authorization'] = Authorization.val
  }
  return config
})

service.interceptors.response.use(
  response => {
    const res = { ...response.data }
    if (res.respStatus === 'ERROR' && !store.getters.dev) {
      Message({
        message: res.msg || res.message || 'Error',
        type: 'error',
        duration: 2 * 1000
      })
      // store.dispatch('user/resetToken').then(async () => {
      //   Message({
      //     message: res.msg || res.message || 'Error',
      //     type: 'error',
      //     duration: 2 * 1000
      //   })
      //   await store.commit('SET_USER_NAME', '')
      //   await location.reload()
      //   await store.dispatch('user/logout')
      // })
    } else if (res.respStatus === 'SUCCESS' || res.message === 'success' || res.code === 200 || res.result === 'success') {
      if (res.data && res.data.login && res.data.login.code === 500) {
        Message({
          message: res.data.login.msg || 'Error',
          type: 'error',
          duration: 2 * 1000
        })
      } else {
        return res
      }
    } else if (res.status === 401 || res.code === 401) {
      Message({
        message: res.message || res.msg || '请求失败',
        type: 'error',
        duration: 2 * 1000
      })
      store.dispatch('user/resetToken').then(async () => {
        await store.commit('SET_USER_NAME', '')
        await location.reload()
        await store.dispatch('user/logout')
      })
    } else {
      Message({
        message: res.message || res.msg || '请求失败',
        type: 'error',
        duration: 2 * 1000
      })
      return Promise.reject(res)
    }
  },
  error => {
    const res = error.response.data
    if (res.code === '400') {
      Message({
        message: res.message + ',' + '请重新登录',
        type: 'error',
        duration: 2 * 1000
      })
      console.log('400 response')
    } else {
      Message({
        message: '系统异常，请稍后重试',
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js